import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ArrowRight = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9.61984 3.95334L13.6665 8L9.61984 12.0467M2.33317 8H13.5532",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
